module.exports = function (data) {
    return {
        recipe: {
            recipeInfo: {
                recipeID: data.recipe.RecipeId,
                recipeName: data.recipe.Title,
            },
            category: data.recipe.CategoryName,
        },
    };
};



// WEBPACK FOOTER //
// ./src/recipe/dtmmapper/recipe-analytics-mapper.js